export const getAdminAuthHeaders = (token, extraHeaders = {}) => {
  const authHeaders = token
    ? { Authorization: `Bearer ${token}` }
    : {};

  return {
    ...authHeaders,
    ...extraHeaders
  };
};
